<template>
    <div>
        <Navbar/>
        <router-view/>
    </div>
</template>
<script>
import Navbar from "./components/Navbar.vue"


export default {
    
    /* eslint-disable no-use-before-define */
    components:{
        Navbar,
    }
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}



</style>
